<template>
  <a-layout-sider :width="'auto'">
    <transition-group name="air__menuFlyout__animation" :duration="1">
      <template v-for="(item, index) in renderedFlyoutItems">
        <div
          :key="index"
          :style="{
            left: `${item.itemDimensions.left + item.itemDimensions.width - 10}px`,
            top: `${item.itemDimensions.top}px`,
          }"
          :class="{
            [$style.air__menuFlyout]: true,
          }"
        >
          <ul :class="$style.air__menuLeft__list" @mouseenter="handleFlyoutContainerOver(item.key)" @mouseleave="handleFlyoutOut(item.key)">
            <template v-for="(item, index) in item.items">
              <item :key="index" :item="item" :styles="$style" :theme="theme" :activeItem="activeItem" />
            </template>
          </ul>
        </div>
      </template>
    </transition-group>
    <div
      :class="{
        [$style.air__menuLeft]: true,
        [$style.air__menuLeft__mobileToggled]: settings.isMobileMenuOpen,
        [$style.air__menuLeft__toggled]: settings.isMenuCollapsed,
        [$style.air__menuLeft__unfixed]: settings.isMenuUnfixed,
        [`${theme}-menu`]: true,
      }"
    >
      <div :class="$style.air__menuLeft__outer">
        <a href="javascript: void(0);" :class="$style.air__menuLeft__mobileToggleButton" @click="toggleMobileMenu">
          <span />
        </a>
        <a href="javascript: void(0);" :class="$style.air__menuLeft__toggleButton" @click="toggleMenu">
          <span />
          <span />
        </a>
        <a href="javascript: void(0);" :class="$style.air__menuLeft__logo">
          <img src="resources/images/truelife-logo.png" alt="Truelife" />
          <div :class="$style.air__menuLeft__logo__name">True Life</div>
          <!-- <div :class="$style.air__menuLeft__logo__descr">Church Dashboard</div> -->
        </a>
        <a href="javascript: void(0);" :class="$style.air__menuLeft__user" v-if="isTruelifeMember">
          <div :class="$style.air__menuLeft__user__avatar">
            <a-avatar :src="getUserPhoto || 'resources/images/avatars/avatar.png'" shape="square" size="large" icon="user" />
          </div>
          <div :class="$style.air__menuLeft__user__name">{{ getUsername }}</div>
          <div :class="$style.air__menuLeft__user__role">{{ $t('menuLeft.user.churchPartner') }}</div>
        </a>
        <a href="javascript: void(0);" :class="$style.air__menuLeft__user" v-else>
          <div :class="$style.air__menuLeft__user__avatar">
            <a-avatar :src="getUserPhoto || 'resources/images/avatars/avatar.png'" shape="square" size="large" icon="user" />
          </div>
          <div :class="$style.air__menuLeft__user__name">{{ getUsername }}</div>
          <div :class="$style.air__menuLeft__user__role">{{ $t('menuLeft.user.evangelismPartner') }}</div>
          <div :class="$style.air__menuLeft__user__role">https://truelife.org/</div>
        </a>
        <vue-custom-scrollbar>
          <div :class="$style.air__menuLeft__container">
            <ul :class="$style.air__menuLeft__list">
              <template v-for="(menuItem, index) in getMenuItems">
                <li :class="$style.air__menuLeft__category" class="menu-category" :key="index">
                  <span>{{ menuItem.owner }}</span>
                </li>
                <template v-for="(item, index) in menuItem.items">
                  <item v-if="!item.children && !item.category" :key="item.key" :item="item" :theme="theme" :styles="$style" :activeItem="activeItem" />
                  <sub-menu
                    v-if="item.children"
                    :key="`${menuItem.owner}${index}`"
                    :item="item"
                    :styles="$style"
                    :activeItem="activeItem"
                    :activeSubmenu="activeSubmenu"
                    :handleSubmenuClick="handleSubmenuClick"
                    :handleFlyoutOver="handleFlyoutOver"
                    :handleFlyoutOut="handleFlyoutOut"
                  />
                  <category v-if="item.category" :key="index" :item="item" :styles="$style" />
                </template>
              </template>
              <template v-if="!isEmpty(getAccountMenu)">
                <li :class="$style.air__menuLeft__category" class="menu-category">
                  <span>Account</span>
                </li>
                <template v-for="(item, index) in getAccountMenu">
                  <item v-if="!item.children && !item.category" :key="item.key" :item="item" :styles="$style" :activeItem="activeItem" />
                  <sub-menu
                    v-if="item.children"
                    :key="index"
                    :item="item"
                    :styles="$style"
                    :activeItem="activeItem"
                    :activeSubmenu="activeSubmenu"
                    :handleSubmenuClick="handleSubmenuClick"
                    :handleFlyoutOver="handleFlyoutOver"
                    :handleFlyoutOut="handleFlyoutOut"
                  />
                  <category v-if="item.category" :key="index" :item="item" :styles="$style" />
                </template>
              </template>
              <item :item="donateMenu" :styles="$style" :activeItem="activeItem" />
            </ul>
          </div>
        </vue-custom-scrollbar>
      </div>
    </div>
    <a href="javascript: void(0);" :class="$style.air__menuLeft__backdrop" @click="toggleMobileMenu" />
  </a-layout-sider>
</template>

<script>
import vueCustomScrollbar from 'vue-custom-scrollbar';
import { find, concat, forEach, isEmpty } from 'lodash';
import { mapState, mapGetters } from 'vuex';
import getMenuData from '@/services/menu';
import SubMenu from './partials/submenu';
import Item from './partials/item';
import Category from './partials/category';
// import 'vue-custom-scrollbar/dist/vueScrollbar.css';

export default {
  name: 'menu-left',
  components: { vueCustomScrollbar, SubMenu, Item, Category },
  computed: {
    ...mapGetters(['theme']),
    ...mapState(['settings', 'user']),
    flyoutActive() {
      return (this.settings.menuType === 'flyout' || this.settings.menuType === 'compact' || this.settings.isMenuCollapsed) && !this.settings.isMobileView;
    },
    getUsername() {
      return `${this.user.user.firstname} ${this.user.user.lastname}`;
    },
    getUserPhoto() {
      return this.user.user.photo_url;
    },
    getMenuItems() {
      return this.menuData.menuItems;
    },
    getAccountMenu() {
      return this.menuData.accountData;
    },
    isTruelifeMember() {
      return this.user.user.isTruelifeMember;
    },
    donateMenu() {
      return {
        title: 'Donate',
        key: 'donate',
        icon: 'fe fe-gift',
        url: '/donate',
      };
    },
    waitingVideos() {
      return this.user.user.waitingVideos;
    },
    newConnections() {
      return this.user.user.newConnections;
    },
  },
  async mounted() {
    this.menuData = await getMenuData();
    this.setActiveItems();
  },
  data() {
    return {
      menuData: [],
      activeSubmenu: '',
      activeItem: '',
      renderedFlyoutItems: {},
      flyoutTimers: {},
    };
  },
  watch: {
    async 'settings.locale'(value) {
      this.menuData = await getMenuData();
    },
    async watingVideos(value) {
      this.menuData = await getMenuData();
    },
    async newConnections(value) {
      this.menuData = await getMenuData();
    },
    $route() {
      this.setActiveItems();
    },
  },
  methods: {
    isEmpty,
    toggleMobileMenu() {
      const setting = 'isMobileMenuOpen';
      const value = !this.settings[setting];
      this.$store.commit('CHANGE_SETTING', { setting, value });
    },
    toggleMenu() {
      const setting = 'isMenuCollapsed';
      const value = !this.settings[setting];
      this.$store.commit('CHANGE_SETTING', { setting, value });
    },
    handleSubmenuClick(key) {
      const currentKey = this.activeSubmenu;
      this.activeSubmenu = currentKey === key ? '' : key;
    },
    setActiveItems() {
      if (this.$route.name === 'donate') {
        this.activeItem = this.$route.name;
      } else if (this.$route.name === 'captureVideo') {
        this.activeItem = this.$route.query.redirectTo;
      } else {
        let menuApp = [];
        forEach(this.getMenuItems, item => (menuApp = concat(menuApp, item.items)));
        const menuData = [...menuApp, ...this.getAccountMenu];
        const pathname = this.$route.path;

        const flattenItems = (items, key) =>
          items.reduce((flattenedItems, item) => {
            flattenedItems.push(item);
            if (Array.isArray(item[key])) {
              return flattenedItems.concat(flattenItems(item[key], key));
            }
            return flattenedItems;
          }, []);
        const activeItem = find(flattenItems(menuData, 'children'), ['url', pathname]);
        if (activeItem) {
          const activeSubmenu = menuData.reduce((key, parent) => {
            if (Array.isArray(parent.children)) {
              parent.children.map(child => {
                if (child.key === activeItem.key) {
                  key = parent;
                }
                return '';
              });
            }
            return key;
          });
          this.activeItem = activeItem.key;
          this.activeSubmenu = activeSubmenu.key;
        }
      }
    },
    handleFlyoutOver(event, key, items) {
      if (this.flyoutActive) {
        clearInterval(this.flyoutTimers[key]);
        const item = event.currentTarget;
        const itemDimensions = item.getBoundingClientRect();
        this.renderedFlyoutItems = {
          ...this.renderedFlyoutItems,
          [key]: {
            key,
            itemDimensions,
            items,
          },
        };
      }
    },
    handleFlyoutOut(key) {
      if (this.flyoutActive) {
        this.flyoutTimers[key] = setTimeout(() => {
          const updatedFlyoutItems = Object.assign({}, this.renderedFlyoutItems);
          delete updatedFlyoutItems[key];
          this.renderedFlyoutItems = {
            ...updatedFlyoutItems,
          };
        }, 100);
      }
    },
    handleFlyoutContainerOver(key) {
      clearInterval(this.flyoutTimers[key]);
    },
  },
};
</script>

<style lang="scss" module>
@import './style.module.scss';
</style>
<style lang="scss">
.menu-category {
  margin-bottom: -12px !important;
}

.dark-theme {
  .dark-menu {
    background: #383838;
    div {
      a {
        span {
          &:before,
          &:after {
            background: white !important;
          }
        }
        div {
          color: white !important;
        }
      }
    }
    .ps-container {
      div {
        ul {
          li {
            &.menu-category {
              span {
                color: white !important;
              }
            }
            a {
              color: white !important;
            }
          }
        }
      }
    }
    .dark-menu-active {
      a,
      .router-link-exact-active {
        background-color: #454545;
      }
    }
  }
}
</style>
